/* eslint-disable max-len */
import { ApolloError } from '@apollo/client';
import { getStructureOutput } from '../../../../api';
import { manageCodeLabelColumns } from '../../../../components';
import { structure } from '../../../../entityModel';
import { ManageStructuresTableBody } from './ManageStructureTableBody';
import { ManageStructuresTableHead } from './ManageStructureTableHead';

interface ManageStructuresTableProps {
  error?: ApolloError;
  loading: boolean;
  data?: getStructureOutput;
  onEdit: (structure: structure) => void;
  onDelete: (structure: structure) => void;
}

export const ManageStructuresTable = ({ error, loading, data, onEdit, onDelete, ...rest }: ManageStructuresTableProps) => {
  return (
    <table className="table table-bordered">
      <ManageStructuresTableHead
        columns={manageCodeLabelColumns}
      />
      <ManageStructuresTableBody
        columns={manageCodeLabelColumns}
        loading={loading}
        error={error}
        data={data}
        onEdit={onEdit}
        onDelete={onDelete}
      />
    </table>
  );
};
